import * as Styles from './styles'

export const SkeletonArea = () => <Styles.SkeletonArea />
